//Obtener datos del footer
export function GetSlidesApi() {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/slide`;
    const params = {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        },
    };

    return fetch(url, params)
        .then(response => {
            return response.json()
                .then(result => {
                    return result;
                })
                .catch(err => {
                    return err.message;
                })
        })
}

export function DeleteSlideApi(token, id) {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/slide/${id}`;

    const params = {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            "x-auth-token": token
        }
    }
    return fetch(url, params)
        .then(response => {
            return response.json();
        })
        .then(result => {
            if (result.slide) {
                return { ok: true, message: result.msg };
            }
            return { ok: false, message: result.msg };
        })
        .catch(err => {
            return { ok: false, message: err.msg };
        });
}

export function SignUpSlideApi(imagen, token) {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/slide`;
    const formData = new FormData();
    formData.append("imagen", imagen, imagen.name);
    const params = {
        method: "POST",
        body: formData,
        headers: {
            "x-auth-token": token
        }
    };
    return fetch(url, params)
        .then(response => {
            return response.json();
        })
        .then(result => {
            if (result.slide) {
                return { ok: true, message: result.msg };
            }
            return { ok: false, message: result.msg };
        })
        .catch(err => {
            return { ok: false, message: err.msg };
        });
}